
/**
 * Clase PoiLayer que extiende la funcionalidad de L.Layer.
 * Gestiona la capa de puntos de interés (POIs) en un mapa Leaflet.
 */
const PoiLayer = L.Layer.extend({
    /**
     * Inicializa la capa con un nombre de clase.
     *
     * @param {string} t - El nombre de la clase para la capa.
     */
    initialize: function(t) {
        this.className = t;
    },
    /**
     * Obtiene el panel de marcadores del mapa.
     *
     * @returns {HTMLElement} El panel de marcadores del mapa.
     */
    getPane: function() {
        return this._map.getPanes().markerPane
    },
    /**
     * Método llamado al agregar la capa al mapa.
     *
     * @param {Object} t - El mapa Leaflet al que se agrega la capa.
     * @returns {Object} La instancia de la capa.
     */
    onAdd: function(t) {
        this._map = t;
        this.displayed = true;
        if( ! this._container ) {
            this._container = L.DomUtil.create("div", "leaflet-layer viewer-pois pois-".concat(this.className));
        }
        this.getPane().appendChild(this._container);
        this._map.on("viewreset", this._reset, this);
        this._map.on("zoomend", this._reset, this);
        this._reset();
        this._markers = {};

        return this;
    },
    /**
     * Genera el HTML para un marcador de POI.
     *
     * @param {string} t - El identificador del POI.
     * @param {Object} o - Las coordenadas del POI.
     * @param {Object} element - Los datos del elemento del POI.
     * @returns {string} El HTML generado para el marcador.
     */
    getHtml: function(t, o, element) {
        const html = element.html
            , s = void 0 === html ? "" : html
            , style = element.style
            , a = void 0 === style ? "" : style
            , p = element.attrs
            , r = void 0 === p ? [] : p
            , l = this._map.latLngToLayerPoint(o);

        return '<div data-id="'.concat(t, '" class="poi-point"\n                    data-lat="').concat(o.lat, '" data-lon="').concat(o.lng, '"\n                    style="transform: translate(').concat(l.x, "px, ").concat(l.y, "px); ").concat(a, '"\n                    ').concat(r ? r.join(" ") : "", ">").concat(s, "</div>")
    },
    /**
     * Agrega múltiples POIs a la capa.
     *
     * @param {string} t - El HTML de los POIs.
     * @param {Object} o - Los datos de los marcadores.
     */
    addPois: function(t, o) {
        if (this._container)
            this._container.insertAdjacentHTML("beforeend", t);
        this._markers = o;
    },
    /**
     * Elimina todos los POIs de la capa.
     */
    removePois: function() {
        if(this._container)
            this._container.innerHTML = "";
    },
    /**
     * Método llamado al eliminar la capa del mapa.
     *
     * @returns {Object} La instancia de la capa.
     */
    onRemove: function() {
        if(this._container)
            this.getPane().removeChild(this._container);
        this.displayed = false;
        this._map.off("viewreset", this._reset, this);

        return this;
    },
    /**
     * Reemplaza un marcador existente con un nuevo HTML.
     *
     * @param {string} t - El identificador del marcador.
     * @param {string} o - El nuevo HTML del marcador.
     */
    replaceMarker: function(t, o) {
        let container = this._container, element;

        if (null === container || void 0 === container)
            element = void 0;
        else
            element = container.querySelector('[data-id="'.concat(t, '"]'));

        if (element)
            element.outerHTML = o;
    },
    /**
     * Obtiene todos los marcadores de la capa.
     *
     * @returns {NodeList|Array} Una lista de elementos de marcadores o un arreglo vacío.
     */
    getAllMarkers: function() {
        let t, container = this._container;

        if(null === container || void 0 === container)
            t = void 0;
        else
            t = container.querySelectorAll("[data-id]");

        if (null !== t && void 0 !== t)
            return t;
        else
            return [];
    },
    /**
     * Resetea la posición de todos los marcadores en la capa.
     */
    _reset: function() {
        if (this._map)
            this.forAllMarkers(this.getPosReset.bind(this));
    },
    /**
     * Aplica una función a todos los marcadores de la capa.
     *
     * @param {Function} t - La función a aplicar a cada marcador.
     */
    forAllMarkers: function(t) {
        let o, i, e = this.getAllMarkers(), s = e.length;
        for (let n = 0; n < s; n++) {
            o = e[n];
            if(this._markers && o.dataset.id && o.dataset.id in this._markers) {
                i = t(this._markers[o.dataset.id]);
                this.setPoistion(o, i)
            }
        }
    },
    /**
     * Calcula la posición de un marcador en la capa.
     *
     * @param {Object} t - Las coordenadas del marcador.
     * @returns {Object} La posición del marcador en la capa.
     */
    getPosReset: function(t) {
        return this._map.latLngToLayerPoint(t)
    },
    /**
     * Establece la posición de un marcador en la capa.
     *
     * @param {HTMLElement} t - El elemento del marcador.
     * @param {Object} o - La posición del marcador.
     */
    setPoistion: function(t, o) {
        t.style.transform = "translate(".concat(o.x, "px, ").concat(o.y, "px)");
    }
})


export default PoiLayer;
